export const PHOTO_WIDTH = 240;
export const PHOTO_HEIGHT = 160;
